import { useEffect, useState } from 'react';
import cookie from 'react-cookies';
import PropTypes from 'prop-types';

/**
 * @param {string} cookieName
 * @param {string} cookieValueOnSave
 * @returns {[boolean,function]}
 */
const useBanner = (cookieName, cookieValueOnSave = 'false') => {
  const [isDisplayed, setDisplayed] = useState(false);

  useEffect(() => {
    setDisplayed(cookie.load(cookieName) !== cookieValueOnSave);
  }, [setDisplayed, cookieName, cookieValueOnSave]);

  function hide() {
    cookie.save(cookieName, cookieValueOnSave, { path: '/' });
    setDisplayed(false);
  }

  return [isDisplayed, hide];
};

useBanner.defaultProps = {
  cookieValueOnSave: 'false'
};

useBanner.propTypes = {
  cookieName: PropTypes.string.isRequired
};

export default useBanner;
